import { Component, HostListener, OnInit } from '@angular/core';
import {
  ModalController,
   NavController,
  ToastController,
  ViewController
} from 'ionic-angular';
import { AuthService } from '../../providers/auth-service'
import { UtilsProvider } from '../../providers/utils/utils';
import { CallcenterProvider } from '../../providers/callcenter/callcenter';
import { Storage } from '@ionic/storage'
import { Subject } from 'rxjs';
import { InformesProvider } from '../../providers/informes/informes';
import { WhatsappPage } from '../whatsapp/whatsapp';
import { HomePage } from '../home/home';
import { ProductosRapidosComponent } from '../../components/productos-rapidos/productos-rapidos';
import { CajaverticalPage } from '../cajavertical/cajavertical';

@Component({
  selector: 'page-callcenter',
  templateUrl: 'callcenter.html',
  providers: [ AuthService, CallcenterProvider, UtilsProvider ]
})
export class CallcenterPage implements OnInit {
  messages: any[] = [];
  message: string = '';
  isMenuOpen: boolean = false; // Variable para controlar el estado del menú
  currentPage: string = '';
  draggedCard: string;
  companies: string[] = [];
  taskGroups: any[] = [];
  estadosGestion: any[] = [];
  accionesEstadosGestion: any[] = [];
  seleccionado
  private comentarioSubject = new Subject<any>();
  isCollapsed: boolean[] = [];
  barraVisibleActualizarProductos:boolean = false
  progreso = 0;
  productoActual = "Cargando datos...";
  diasHistoricoCierreEnCallCenter
  constructor(public navCtrl: NavController,
    public viewControllers:ViewController,
    public callcenterProvider: CallcenterProvider ,
    public storages:Storage,
    public utils:UtilsProvider,
    public toastControllers:ToastController,
    public servicioDescargar: InformesProvider,
    public modalControllers: ModalController
  ) {
  }

  ngOnInit() {
    localStorage.removeItem('clientesIdCallcenter');
    this.isCollapsed = this.accionesEstadosGestion.map(() => true);
  }


  toggleChatMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }


  goToPage(page: string) {
    if(page === 'productos-rapidos') {
          this.navCtrl.push(ProductosRapidosComponent)
    } else if(page === 'Page1') {
      this.navCtrl.push(CajaverticalPage)
    } else {
      this.currentPage = page;
    }
  }

  atras() {
    // this.navCtrl.setRoot(CreditosComponent);
    this.navCtrl.setRoot(HomePage);
  }
  onDragStart(event: DragEvent, groupIndex: number, taskIndex: number, deDondeViene:string) {
    if (event.dataTransfer) {
        event.dataTransfer.setData('text/plain', JSON.stringify({ groupIndex, taskIndex,deDondeViene  }));
        console.log('Inicio de arrastre:', groupIndex, 'Tarea:', taskIndex);
    }
  }

async onDrop(event: DragEvent, targetGroupIndex: number, targetTaskIndex: number) {
  event.preventDefault();

  const dataTransfer = event.dataTransfer;
  if (dataTransfer) {
    const data = dataTransfer.getData('text/plain');
    if (data) {
      const { groupIndex, taskIndex } = JSON.parse(data);

      if (groupIndex !== targetGroupIndex || taskIndex !== targetTaskIndex) {
        const movedTask = this.accionesEstadosGestion[groupIndex].gestiones[taskIndex];
        if(taskIndex > 0) {
          this.accionesEstadosGestion[groupIndex].gestiones.splice(taskIndex, 1);
        }

        let accionesEstadosGestionIndividualId = this.accionesEstadosGestion[targetGroupIndex].gestiones[targetTaskIndex].accionesEstadosGestionIndividualId
        let data = await this.actualizarAccionesEstadosGestionIndividual(accionesEstadosGestionIndividualId,movedTask.clientesId)

        if (data && data.length > 0) {
          data.forEach((item: any) => {
            let accionesEstadosGestionIndividualId = item.accionesEstadosGestionIndividualId;
            let accionesEstadosGestionIndividualPorClienteId = item.accionesEstadosGestionIndividualPorClienteId;

            // Encuentra el grupo y la tarea correspondiente y actualiza sus propiedades
            this.accionesEstadosGestion.forEach((group: any) => {
              group.gestiones.forEach((task: any) => {
                if (task.accionesEstadosGestionIndividualId === accionesEstadosGestionIndividualId) {
                  task.accionesEstadosGestionIndividualPorClienteId = accionesEstadosGestionIndividualPorClienteId;
                }
              });
            });
          });
        }
        this.accionesEstadosGestion[targetGroupIndex].gestiones.splice(targetTaskIndex, 0, movedTask);
      } else {
        console.log('No se puede mover la tarea a la misma posición.');
      }
    }
  }
}

onDragOver(event: DragEvent) {
    event.preventDefault();
}

  ionViewDidLoad() {
    let datosGenerales = localStorage.getItem('datosGenerales')
    let datosGeneralesJSON = JSON.parse(datosGenerales)
    if(datosGeneralesJSON && datosGeneralesJSON["diasHistoricoCierreEnCallCenter"]) {
      this.diasHistoricoCierreEnCallCenter = datosGeneralesJSON["diasHistoricoCierreEnCallCenter"] == undefined ? 7 : datosGeneralesJSON["diasHistoricoCierreEnCallCenter"]
    }
    this.cargarServicio()
  }

    getCompaniesFromTasks(tasks: Task[]): string[] {
      const companies = tasks.map(task => task.company);
      return Array.from(new Set(companies));
    }

  toggleGroup(group:any) {
    group.open = !group.open;
  }

  async cargarServicio() {
    let companiasId = await localStorage.getItem('companiasId')
    let datos = this.callcenterProvider.buscarEstadosGestion(companiasId,'C')
    let response = (await datos).json()

    if(response && response.data && response.data[0].length>0) {
      let valores = response.data[0]
      this.agruparEstadosGestion(valores, companiasId);
      return
    }
  }

  async agruparEstadosGestion(valores: any, companiasId: any) {
    // Primero, realiza la consulta inicial de valores y la consulta de los usuarios
    const datosusuarios = this.callcenterProvider.buscarEstadosGestion(companiasId, 'U');
    const responseusuarios = (await datosusuarios).json();

    // Combina los datos de ambas consultas en un solo array
    const todosLosDatos = [...valores, ...responseusuarios.data[0]];

    // Agrupar los datos combinados
    const agrupados = todosLosDatos.reduce((acc, data) => {
      const descripcion = data.descripcion;
      const imagen = data.imagen;
      const cuantos = data.cuantos;
      const interno = data.interno == 'S' ? true : false;

      if (!acc[descripcion]) {
        acc[descripcion] = { descripcion, imagen, cuantos, interno, gestiones: [], open: false }; // open controla si se muestra el grupo
      }
      acc[descripcion].gestiones.push(data);
      return acc;
    }, {});

    // Ahora asignamos el resultado de los estados agrupados a `estadosGestion`
    this.estadosGestion = Object.keys(agrupados)
      .map(key => agrupados[key])
      .sort((a, b) => a.prioridad - b.prioridad); // Ordena según la propiedad "prioridad"

    // Para cada gestión dentro de `estadosGestion`, generamos un color aleatorio
    this.estadosGestion.forEach(estado => {
      estado.gestiones.forEach(gestion => {
        gestion.color = this.generateRandomColor(); // Método para generar color aleatorio
      });
    });
  }

  getInitials(nombreCompleto: string): string {
    if(nombreCompleto == undefined) {
      nombreCompleto = 'sin valores'
    }
    const nombres = nombreCompleto.split(' ');
    const iniciales = nombres.map(nombre => nombre.charAt(0)).join('');
    return iniciales.toUpperCase();
  }

  generateRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  toggleEstadosGestion(group:any) {
    group.open = !group.open;
    this.goToPage('Page2')
    if(group.open ) {
      let estadosGestionId = group.gestiones[0].estadosGestionId
      if(estadosGestionId == undefined) {

      } else {
        this.buscarAccionesEstadosGestion(estadosGestionId,-1)
      }
    }
  }

  traerAcciones(groupIndex: number, task: any,group:any) {
    if( task.clientesId == undefined) {
      return
    }
    let clientesId = task.clientesId;
    let estadosGestionId = task.estadosGestionId;
    this.estadosGestion.forEach(group => {
      group.open = false;
    })

    let tipo = task.tipo
    if(tipo === 'U') {
      this.buscarAccionesEstadosGestionUsuarios(estadosGestionId, clientesId);
    } else {
      this.buscarAccionesEstadosGestion(estadosGestionId, clientesId,tipo == undefined ? 'C' : tipo);
    }
  }

  async buscarAccionesEstadosGestion(estadosGestionId:any,clientesId:any,tipo:any = 'C') {
    let companiasId = await localStorage.getItem('companiasId')
    this.accionesEstadosGestion = []
    let datos = await this.callcenterProvider.buscarAccionesEstadosGestion(companiasId,estadosGestionId,clientesId,tipo)

    let response = (await datos).json()
    if(response && response.data && response.data[0].length>0) {
      let valores = response.data[0]
      let datosCliente = response.data[1]
      let nuevaData = response.data.length > 2 ? response.data.slice(2): []

      if(nuevaData.length>0 && nuevaData[0] && nuevaData[0][0] && nuevaData[0][0].hasOwnProperty('BUSCARCLIENTES')) {
          let clientesIdCallcenter = nuevaData[0][0].clientesId
          localStorage.removeItem('clientesIdCallcenter');
          localStorage.setItem('clientesIdCallcenter', clientesIdCallcenter); // Guardar en localStorage
          this.currentPage = 'null';
          this.currentPage = 'page-clientes';
          return;
      }
      this.agruparAccionesEstadosGestion(valores,datosCliente,nuevaData);
      let arrayPropiedadesValores = Object.keys(valores).map(key => {
        return { propiedad: key, valor: valores[key] };
      });
     }
  }


  agruparAccionesEstadosGestion(valores:any,datosCliente:any,nuevaData:any) {
    const agrupados = valores.reduce((acc, data) => {
      const descripcion = data.descripcion;
      const imagen = data.imagen;
      const cuantos = data.cuantos;
      const interno = data.interno == 'S' ? true : false
      const accionesEstadosGestionIndividualPorClienteId = data.accionesEstadosGestionIndividualPorClienteId
      const accionesEstadosGestionIndividual = data.accionesEstadosGestionIndividual
      let nuevoComentario = data.valorDescripcion
      let nuevoComentarioSinFormatear = ''
      if (!isNaN(Number(nuevoComentario))) {
        nuevoComentarioSinFormatear = nuevoComentario
        nuevoComentario = Number(nuevoComentario).toLocaleString('es-ES');
      }
      if (!acc[descripcion]) {
        acc[descripcion] = { descripcion, imagen, cuantos, interno, accionesEstadosGestionIndividualPorClienteId,nuevoComentario,nuevoComentarioSinFormatear, accionesEstadosGestionIndividual, gestiones: [], open: false }; // open controla si se muestra el grupo
      }
      acc[descripcion].gestiones.push(data);
      return acc;
    }, {});

    this.accionesEstadosGestion = Object.keys(agrupados).map(key => agrupados[key]);

    this.accionesEstadosGestion = Object.keys(agrupados)
    .map(key => agrupados[key])
    .sort((a, b) => a.prioridad - b.prioridad);

    this.accionesEstadosGestion.forEach(estado => {
      estado.gestiones.forEach(gestion => {
        gestion.color = this.generateRandomColor();
      });
    });

    const nuevoRegistro = { ...datosCliente[0] };
    if (!nuevoRegistro.gestiones) {
      nuevoRegistro.gestiones = [];
    }
    nuevoRegistro.gestiones.unshift(nuevoRegistro);
    this.accionesEstadosGestion.unshift(nuevoRegistro);
    if(nuevaData.length === 0) {
      this.agregarNuevaData(datosCliente)

    } else {
      this.agregarNuevaData(nuevaData)
    }

  }


  async actualizarAccionesEstadosGestionIndividual(accionesEstadosGestionIndividualId:any,clientesId:any) {
    let companiasId = await localStorage.getItem('companiasId')
    let datos = this.callcenterProvider.actualizarAccionesEstadosGestionIndividual(companiasId,accionesEstadosGestionIndividualId,clientesId)
    let response = (await datos).json()
    if(response && response.data && response.data[0].length>0) {
      let valores = response.data[0]
      return valores
    }
    return []
  }



  onComentarioChange(card: any, index: number) {
    let valorIngresado = card.nuevoComentario;

    // Eliminar cualquier separador de miles para evitar conflictos al convertir de nuevo
    valorIngresado = valorIngresado.replace(/\./g, '');

    // Actualizar el valor sin formatear
    card.nuevoComentarioSinFormatear = valorIngresado;
  }

  onComentarioBlur(card: any, index: number) {
    let valorIngresado = card.nuevoComentarioSinFormatear;

    // Verificar si el valor es numérico después de eliminar los puntos
    if (!isNaN(Number(valorIngresado))) {
      card.nuevoComentarioSinFormatear = valorIngresado;
      // Convertir el valor numérico en formato con separadores de miles
      const numeroFormateado = Number(valorIngresado).toLocaleString('es-ES');
      // Asignar el valor formateado visualmente, pero mantenerlo como cadena

      setTimeout(() => {
            card.nuevoComentario = numeroFormateado;
        }, 0);
    }
  }


  async guardarComentario(card: any, index: number) {
    let comentario = card.nuevoComentarioSinFormatear;

    // Si nuevoComentario es más largo, úsalo en lugar de nuevoComentarioSinFormatear
    if (card.nuevoComentario.length > comentario.length) {
      comentario = card.nuevoComentario.replace(/\./g, ''); // Eliminar separadores de miles
    }

    if (card.accionesEstadosGestionIndividualPorClienteId) {
      if (comentario && comentario.trim()) {
        card.nuevoComentarioSinFormatear = '';
        await this.actualizaraccionesEstadosGestionIndividualPorClienteIdComentario(card.accionesEstadosGestionIndividualPorClienteId, comentario);
        this.mensajeToast('Registro guardado con éxito');

      } else {
        console.log('Comentario vacío, no se guardó.');
      }
    } else {
      console.log('No se encontró accionesEstadosGestionIndividualPorClienteId.');
    }
  }


  async actualizaraccionesEstadosGestionIndividualPorClienteIdComentario(accionesEstadosGestionIndividualPorClienteId:any,comentario:any) {
    let companiasId = await localStorage.getItem('companiasId')
    let datos = this.callcenterProvider.actualizaraccionesEstadosGestionIndividualPorClienteIdComentario(companiasId,accionesEstadosGestionIndividualPorClienteId,comentario)
    let response = (await datos).json()
    if(response && response.data && response.data[0].length>0) {
      let valores = response.data[0]
      console.log(valores)
      return
    }
  }

  mensajeToast(mensaje: string) {
    let item =    {
        "duration": 1000,
        "position": "buttom"
      }
      item["message"] = mensaje;
    let toast = this.toastControllers.create(item);
    toast.present();
  }
  selectInputContent(event: any) {
    const inputElement = event.target;

    if (inputElement && inputElement.value) {
      // Usar un pequeño retraso para asegurarse de que el campo está completamente enfocado
      setTimeout(() => {
        inputElement.setSelectionRange(0, inputElement.value.length);
      }, 0);
    }
  }
  getDynamicFields(item: any): any[] {

    return Object.keys(item).map(key => {
      return { field: key, value: item[key] };
    });
  }

agregarNuevaData(arraysDeData: any[][]) {
  // Unificamos todos los arrays en uno solo usando reduce
  const newData = arraysDeData.reduce((acc, curr) => acc.concat(curr), []);
  // Aplicamos la lógica con el array unificado
  this.accionesEstadosGestion.forEach((card, index) => {
    const gestionesActuales = card.gestiones || [];

    // Filtramos las nuevas gestiones basándonos en `clientesId` y `estadosGestionId`
    let nuevasGestiones = newData.filter(item =>
      item.clientesId === card.clientesId &&
      item.estadosGestionId === card.estadosGestionId
    );
    // Si hay nuevas gestiones, las insertamos al inicio y las asignamos a un nuevo campo
    if (nuevasGestiones.length > 0) {
      const filtradas = nuevasGestiones
      .filter(gestion => gestion.hasOwnProperty("ReciboCaja")) // Verifica si existe la propiedad
      .map(gestion => ({
        fecharecibocaja:gestion.numeroTelefono,
        ReciboCaja: gestion.valorDescripcion,
        nombreCompleto:gestion.nombreCompleto
      }));

    // Si hay gestiones con ReciboCaja, asignamos la lista filtrada.
    // Si NO hay ninguna con ReciboCaja, dejamos nuevasGestiones sin cambios.
    this.accionesEstadosGestion[index].nuevasGestiones = filtradas.length > 0 ? filtradas : [...nuevasGestiones];

    }

  });
}

  toggleCollapse(index: number) {
    this.isCollapsed[index] = !this.isCollapsed[index];
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    const firstTask = document.querySelector('.first-task') as HTMLElement;
    const container = document.querySelector('#container-tasks') as HTMLElement;

    if (firstTask && container) {
      const containerRect = container.getBoundingClientRect();
      const firstTaskRect = firstTask.getBoundingClientRect();

      if (containerRect.top < 0) {
        firstTask.style.position = 'fixed';
        firstTask.style.top = '0';
      } else {
        firstTask.style.position = 'relative';
        firstTask.style.top = 'initial';
      }
    }
  }

  filterTasks(gestiones: any[], searchText: string) {
    if (!searchText) {
      return gestiones;
    }
    const lowerSearchText = searchText.toLowerCase();
    return gestiones.filter(task =>
      task.nombreCompleto.toLowerCase().includes(lowerSearchText) ||
      task.numeroTelefono.includes(lowerSearchText)
    );
  }


  selectInputContentBuscador(event: any) {
    const inputElement = event.target;
    if(inputElement && inputElement.value) {
      inputElement.setSelectionRange(0, inputElement.value.length);
    }
  }

  descargarExcel(gestionInterna: any) {
    const excludeColumns = ['fecharecibocaja','nombreCompleto'];
    let data = [this.convertToExcelFormat(gestionInterna, excludeColumns)];
    data = data && data[0] && data[0][0] ? data[0] : data
    this.servicioDescargar.exportToExcel(data, 'gestion_interna')
  }

  // convertToExcelFormat(item: any): any {
  //   const result = {};
  //   this.getDynamicFields(item).forEach(field => {
  //     result[field.field] = field.value;
  //   });
  //   return result;
  // }

  convertToExcelFormat(item: any, excludeFields: string[] = []): any[] {
    let result: any[] = [];

    let tieneReciboCaja = false;
    let rowBase: any = {}; // Objeto base para las filas

    // Nombre dinámico de la columna ReciboCaja con fecha
    const columnName = `ReciboCaja ${item.fecharecibocaja} - ${item.nombreCompleto}`;

    // Extraer los datos dinámicos
    this.getDynamicFields(item).forEach(field => {
        // Excluir las columnas no deseadas (compatible con Ionic 3)
        if (excludeFields.indexOf(field.field) !== -1) {
            return; // Salta este campo y no lo agrega
        }

        if (field.field === 'ReciboCaja' && field.value) {
            tieneReciboCaja = true;
            const lines = field.value.split('\n').filter(line => line.trim() !== '');

            lines.forEach(line => {
                result.push({ ...rowBase, [columnName]: line }); // Agregar dinámicamente el nombre de la columna
            });
        } else {
            rowBase[field.field] = field.value; // Agregar los demás campos si no están excluidos
        }
    });

    // Si no tiene ReciboCaja, agregamos la fila normal sin la fecha
    if (!tieneReciboCaja) {
        result.push({ ...rowBase });
    }

    return result; // Devuelve un array plano con la fecha en el nombre de la columna
}


  imprimir(gestionInterna: any) {
    let data = this.convertToExcelFormat(gestionInterna);
    const tieneReciboCaja = data.some(item =>
      Object.keys(item).some(key => key.includes("ReciboCaja"))
    );
    if(tieneReciboCaja) {
      data = data && data[0] && data[0][0] ? data[0] : data
    } else {
      data = data && data[0] && data[0][0] ? data[0] : data[0]
    }

    const printContent = this.generatePrintContent(data,tieneReciboCaja);
    this.sendToPrinter(printContent);
  }

  generatePrintContent(data: any, recibocaja:boolean = false): string {
    let content = ''

    if(!recibocaja) {
      content = 'Información de Gestión Interna\n\n';
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          content += `${key}: ${data[key]}\n`;
        }
      }
    } else {
      data.forEach(item => {
        // Buscar la clave que contiene "ReciboCaja"
          for (const key in item) {
              if (key.includes("ReciboCaja")) {
                  content += `${item[key]}\n`; // Agregar el valor al contenido
              }
          }
      });
    }


    return content;
  }

  sendToPrinter(content: string) {
    const printWindow = window.open('', '', 'height=400,width=800');
    printWindow.document.write('<html><head><title>Imprimir Información</title></head><body>');
    printWindow.document.write('<pre>' + content + '</pre>');
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  }

  enviarWhatsApp(gestionInterna: any) {
    const data = this.convertToExcelFormat(gestionInterna);
    const message = this.convertToReciboCajaFormat(data);
    this.abrirWhatsApp(message)
  }

  generateWhatsAppMessage(data: any): any {
    const result = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        result[key] = { reciboCaja: data[key].reciboCaja };
      }
    }
    return result;
  }

  convertToReciboCajaFormat(item: any): any {
    const result = {};
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        result[key] = { reciboCaja: item[key] };
      }
    }
    return result;
  }


  async abrirWhatsApp(mensaje:any){
      let numeroTelefono = ''
      let modal = this.modalControllers.create(WhatsappPage, { dataImprimir: mensaje, numeroTelefono: numeroTelefono, espacios: false }
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
        }
      })
    }

  isPageClientesActive(): boolean {
    switch (this.currentPage) {
      case 'page-clientes':
        return this.currentPage === 'page-clientes';
      case 'page-cuentas-por-cobrar-creditos':
        return this.currentPage === 'page-cuentas-por-cobrar-creditos';
      case 'informe-reimprimir-recibo-caja':
        return this.currentPage === 'informe-reimprimir-recibo-caja';
      case 'productos-rapidos':
        return this.currentPage === 'productos-rapidos';
      case 'page-productos-por-grupos-drag':
        return this.currentPage === 'page-productos-por-grupos-drag';
      default:
        return false;
    }
  }

  async buscarAccionesEstadosGestionUsuarios(estadosGestionId: any, clientesId: any, tipo: any = 'U') {
    let companiasId = await localStorage.getItem('companiasId');
    this.accionesEstadosGestion = [];

    let valoresCompletos: any[] = [];
    let datosAgrupadosCompletos: any[] = [];
    let nuevaDataCompletos: any[] = [];
    // Inicializar barra de progreso
    this.barraVisibleActualizarProductos = true;
    this.progreso = 0;
    this.productoActual = "Cargando datos...";
    // Obtener las fechas desde hoy hasta hace 7 días
    let fechas = [];
    this.diasHistoricoCierreEnCallCenter = this.diasHistoricoCierreEnCallCenter == undefined ? 7 : this.diasHistoricoCierreEnCallCenter
    let cuantos = Number(this.diasHistoricoCierreEnCallCenter)
    for (let i = 0; i < cuantos; i++) {
        let fecha = new Date();
        fecha.setDate(fecha.getDate() - i);
        let fechaStr = fecha.toISOString().split('T')[0]; // Formato YYYY-MM-DD
        fechas.push(fechaStr);
    }

    // Recorrer cada fecha y acumular los datos antes de llamar a agruparAccionesEstadosGestion
    for (let i = 0; i < fechas.length; i++) {
        let fecha = fechas[i];
        let datos = this.callcenterProvider.buscarAccionesEstadosGestion(companiasId, estadosGestionId ? estadosGestionId : 0, clientesId, tipo, fecha);
        let response = await (await datos).json();

        if (response && response.data && response.data[0].length > 0) {
            let valores = response.data[0];
            let datosCliente = response.data[1];
            let nuevaData = response.data.length > 2 ? response.data.slice(2) : [];

            // Agrupar datos del cliente
            const agruparDatosCliente = function(datosCliente: any[]) {
                if (!datosCliente || datosCliente.length === 0) return null;
                let base = Object.assign({}, datosCliente[0]);
                base.valorDescripcion = '';

                for (let i = 0; i < datosCliente.length; i++) {
                    let descripcion = datosCliente[i].ReciboCaja;
                    if (descripcion && descripcion.trim() !== '') {
                        base.valorDescripcion += descripcion.trim() + '\n';
                    }
                }

                base.valorDescripcion = base.valorDescripcion.trim();
                return base;
            };

            let datosAgrupados = agruparDatosCliente(datosCliente);
            // const reciboPattern = /DETALLE\s+VENTAS\s*\n+={5,}\s*\n+CANTIDAD\s+NOMBRE\s+VALOR\s*\n+[-]+\n+(\d+)/;

            // if (
            //     datosAgrupados &&
            //     typeof datosAgrupados.valorDescripcion === 'string' &&
            //     reciboPattern.test(datosAgrupados.valorDescripcion)
            // ) {
            let datosAgrupadosValidados = [{
                descripcion: datosAgrupados && datosAgrupados.descripcion ? datosAgrupados.descripcion : "SIN DESCRIPCIÓN",
                clientesId: datosAgrupados && datosAgrupados.clientesId ? datosAgrupados.clientesId : 0,
                imagen: datosAgrupados && datosAgrupados.imagen ? datosAgrupados.imagen : "",
                cuantos: datosAgrupados && datosAgrupados.cuantos ? datosAgrupados.cuantos : 0,
                interno: datosAgrupados && datosAgrupados.interno ? datosAgrupados.interno : false,
                accionesEstadosGestionIndividualPorClienteId: datosAgrupados && datosAgrupados.accionesEstadosGestionIndividualPorClienteId
                    ? datosAgrupados.accionesEstadosGestionIndividualPorClienteId : 0,
                accionesEstadosGestionIndividual: datosAgrupados && datosAgrupados.accionesEstadosGestionIndividual
                    ? datosAgrupados.accionesEstadosGestionIndividual : null,
                valorDescripcion: datosAgrupados && datosAgrupados.valorDescripcion
                    ? datosAgrupados.valorDescripcion : "",
                prioridad: datosAgrupados && datosAgrupados.prioridad ? datosAgrupados.prioridad : 1,
                ReciboCaja: datosAgrupados && datosAgrupados.ReciboCaja ? datosAgrupados.ReciboCaja : "",
                estadosGestionId: datosAgrupados && datosAgrupados.estadosGestionId ? datosAgrupados.estadosGestionId : 0,
                gestiones: datosAgrupados && Array.isArray(datosAgrupados.gestiones) ? datosAgrupados.gestiones : [],
                nombreCompleto: datosAgrupados && datosAgrupados.nombreCompleto ? datosAgrupados.nombreCompleto : "",
                numeroTelefono: datosAgrupados && datosAgrupados.numeroTelefono ? datosAgrupados.numeroTelefono : ""
            }];
                        // Guardamos los datos en arrays en lugar de llamar a agruparAccionesEstadosGestion de inmediato
                        valoresCompletos = valoresCompletos.concat(valores);
                        datosAgrupadosCompletos = datosAgrupadosCompletos.concat(datosAgrupadosValidados);
                        nuevaDataCompletos = nuevaDataCompletos.concat(nuevaData);
          // }


        }
          // Actualizar barra de progreso
          this.progreso = ((i + 1) / cuantos) * 100; // Calcular porcentaje

          this.productoActual = `Cargando datos (${i + 1}/${cuantos.toString()})...`;
    }

    // Una vez que terminan todas las peticiones, llamamos a agruparAccionesEstadosGestion con toda la información recopilada
    if (valoresCompletos.length > 0) {
        this.agruparAccionesEstadosGestion(valoresCompletos, datosAgrupadosCompletos, nuevaDataCompletos);
    }
    this.barraVisibleActualizarProductos = false;
}

}

class Task {
  public company: string;
  public description: string;
  public date: Date;
  public time: string;
  public progress: number;
}



// WEBPACK FOOTER //
// ./src/pages/callcenter/callcenter.ts